// Хелперы localStorage. Всё, что оболочка обязана помнить между сеансами:
// тема, пара шрифтов, раскладка и пропорции, набор открытых окон (критерий приёмки 3 и 7).
// Приватный режим браузера может кидать на записи — молча игнорируем.

const PREFIX = 'agentbox.'

export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    if (raw === null) return fallback
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function save(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    // квота или приватный режим — не критично
  }
}

export function drop(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key)
  } catch {
    // см. выше
  }
}

/** Пишет значение только если оно изменилось: subscribe стора зовётся на каждый set. */
const cache = new Map<string, string>()
export function saveIfChanged(key: string, value: unknown): void {
  const raw = JSON.stringify(value)
  if (cache.get(key) === raw) return
  cache.set(key, raw)
  try {
    localStorage.setItem(PREFIX + key, raw)
  } catch {
    // см. выше
  }
}
